import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function loadComponent(component) {
  return () => import(/* webpackChunkName: "component-[request]" */ `@/components/${component}.vue`)
}

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: loadComponent('Auth/Login')
    },
    {
      path: '/logout',
      name: 'Logout',
      component: loadComponent('Auth/Logout')
    },
    {
      path: '/account',
      name: 'Account',
      component: loadComponent('Auth/Account')
    },
    {
      path: '/home',
      name: process.env.VUE_APP_HOME_VUE,
      component: loadComponent(`Home/${process.env.VUE_APP_HOME_VUE}`)
    },
    {
      path: '/export',
      name: 'Export',
      component: loadComponent('Export/Export')
    },
    {
      path: '/graph',
      name: 'GraphSelectForm',
      component: loadComponent('Graph/GraphSelectForm')
    },
    {
      path: '/graph/devicetype/:deviceID',
      name: 'DeviceTypeGraph',
      component: loadComponent('Graph/DeviceTypeGraph')
    },
    {
      path: '/organisations',
      name: 'OrganisationList',
      component: loadComponent('Models/Organisation/List')
    },
    {
      path: '/organisations/:id',
      name: 'OrganisationSingle',
      component: loadComponent('Models/Organisation/Single')
    },
    {
      path: '/projectgroups',
      name: 'ProjectGroupList',
      component: loadComponent('Models/ProjectGroup/List')
    },
    {
      path: '/projectgroups/:id',
      name: 'ProjectGroupSingle',
      component: loadComponent('Models/ProjectGroup/Single')
    },
    {
      path: '/devicetypes',
      name: 'DeviceTypeList',
      component: loadComponent('Models/DeviceType/List')
    },
    {
      path: '/devicetypes/:id',
      name: 'DeviceTypeSingle',
      component: loadComponent('Models/DeviceType/Single')
    },
    {
      path: '/devices',
      name: 'DeviceList',
      component: loadComponent('Models/Device/List')
    },
    {
      path: '/changepassword',
      name: 'ChangePassword',
      component: loadComponent('Auth/ChangePassword')
    },

    //
    //   Manifest
    //
    {
      path: '/groupinfos',
      name: 'GroupInfos',
      component: loadComponent('Models/GroupInfo/List')
    },
    {
      path: '/groupinfos/:id',
      name: 'GroupSingle',
      component: loadComponent('Models/GroupInfo/Single')
    },

    {
      path: '/assetinfos',
      name: 'Asset Info',
      component: loadComponent('Models/Assetinfo/List')
    },
    {
      path: '/assetinfos/:id',
      name: 'AssetSingle',
      component: loadComponent('Models/Assetinfo/Single')
    },
    {
      path: '/physicalinfos',
      name: 'Physical Info',
      component: loadComponent('Models/Physicalinfo/List')
    },


    //
    //   Sigfox
    //
    {
      path: '/sigfox_dashboard',
      name: 'SigfoxDashboard',
      component: loadComponent('Sigfox/Dashboard')
    }
  ]
})
